import React from "react";
import { Grid, Stack } from "@chakra-ui/react";
import { Page } from "../../components/Page";
import { useSyncAuditsWithSelectedRound, useSyncQuestionsWithSelectedRound } from "./QuestionnaireRound/RoundService";

const IssbContainer = ({ margin = "15%", children, spacing = 10 }) => {
  useSyncQuestionsWithSelectedRound();
  useSyncAuditsWithSelectedRound();

  return (
    <Grid
      id="issb-container"
      templateColumns="1fr"
      gap={0}
      position="relative"
      width="100%"
      bg="pureWhite"
    >
      <Page>
        <Stack spacing={spacing} p={4} bg="pureWhite" marginLeft={margin} marginRight={margin}>
          {children}
        </Stack>
      </Page>
    </Grid>
  );
};

export default IssbContainer;
